import { Component, OnInit } from '@angular/core';
import { AppServiceService } from 'src/app/api/app-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';


declare var config: any;

@Component({
  selector: 'app-update',
  templateUrl: './app-update.page.html',
  styleUrls: ['./app-update.page.scss'],
})
export class AppUpdatePage implements OnInit {

  public appDownloadLink:string = '';

  constructor(public appService: AppServiceService,private router: Router,public platform: Platform,public inAppBrowser:InAppBrowser) {

    
  }

  ngOnInit() {
    let list = document.getElementsByClassName('main-outlet-content');
    if(list.item(0)){
      list.item(0).setAttribute('style','height:100% !important');
    }
    
  }


  downloadUpdate(){
    if (this.platform.is('android')) {
      if(this.appService.appObject.settings && this.appService.appObject.settings.android_link) this.appDownloadLink = this.appService.appObject.settings.android_link;
    } else if (this.platform.is('ios')) {
      if(this.appService.appObject.settings && this.appService.appObject.settings.ios_link) this.appDownloadLink = this.appService.appObject.settings.ios_link;
    }
    
    // if(this.appDownloadLink) this.inAppBrowser.create(decodeURI(this.appDownloadLink));
    if(this.appDownloadLink) {
      if(this.platform.is('android')){
        try {
          // let splittedLink = this.appDownloadLink.split('id=');
          // const packageName = splittedLink[splittedLink.length - 1].trim();
          // const marketUrl = `market://details?id=${packageName}`;
          // const webUrl = `https://play.google.com/store/apps/details?id=${packageName}`;
          
          // const iframe = document.createElement('iframe');
          // iframe.style.display = 'none';
          // iframe.src = marketUrl;
          // document.body.appendChild(iframe);

          // // Try opening the market:// link first
          // const timeout = setTimeout(() => {
          //   window.location.href = webUrl; // Fallback if market:// didn't work
          // }, 5000); // Wait 2 seconds to confirm failure

          // // Detect visibility change (if user leaves the browser, it means market:// worked)
          // document.addEventListener('visibilitychange', () => {
          //   if (document.hidden) {
          //     clearTimeout(timeout); // Stop fallback if Play Store was opened
          //   }
          // });

          // // Clean up iframe after 3 seconds
          // setTimeout(() => {
          //   document.body.removeChild(iframe);
          // }, 6000);

          /* 
            Above code is the best solution, but since we don't have apps in any other app stores we don't need market:// to be opened 
            So open in browser and the browser will open the app store
          */
          // window.location.href = this.appDownloadLink;
          
          // Use native intent for Android to avoid ERR_UNKNOWN_URL_SCHEME
          window.open(this.appDownloadLink, '_blank');
        } catch (error) {
          this.appService.showToast(JSON.stringify(error) , 'danger');
        }

      }else{
        this.inAppBrowser.create(decodeURI(this.appDownloadLink));
      }
    }
  }

}
